import * as Sentry from "@sentry/react";
import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import ReactPlayer from "react-player";
import { useDispatch } from "react-redux";

import COLOR from "utils/constants/color";
import Loading from "components/Loading";
import PageImagePicker from "components/AdminBooks/PageImagePicker";
import { cloneDeep, find, get, has, map, filter } from "lodash";
import moment from "moment-timezone";
import styled from "styled-components";
import { Row ,} from "antd";
import { DeleteModal } from "components/Dialog";
import { InteractionCategoryType } from "utils/config/reference";
import AudioPicker from "../AudioPicker";
import VideoPicker from "../VideoPicker";
import { EditTranscript } from "./SrtEditor";
import SentryWrap from 'components/Sentry';

import {
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Select,
  TextField,
  TextareaAutosize,

} from '@mui/material';
import { makeStyles } from '@mui/styles';
import {
  Add,
  CheckCircle,
  Close,
  Delete,
} from '@mui/icons-material';

import {
  handleCreateInteractions,
  handleDeleteInteractions,
  handleGetTranscationProgress,
  handleMediaConverterTranscriptForVStream,
  handleTranscriptInteraction,
  handleTranscriptStatusCheck,
  handleUpdateInteractions,
} from "store/interactions/thunks";
import { useAlertLoading } from "components/UI/alertSakeBar/alertProvider";
import YouTubePlayer from "components/ebook/YtPlayer";
import { isYoutubeUrl } from "utils/methods/textMethod";
import usePermissionForUser from "components/hooks/permissions/usePermissionForUser";
import TranscriptWithAudio from "components/UI/transcriptWithAudio/transcriptWithAudio";
import { AudioDownloadButton } from "components/UI";


const TYPES = {
  audio:"audio",
  video:"video",
  youtube:"youtube"
}






const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  @media only screen and (max-width: 600px) {
    min-width: 90% !important;
  }
`;

const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
`;
const LinkArea = styled.div`
  padding: 10px;
  margin: 2px;
  border: 1px dashed;
  margin-top: 24px;
`;
const TitleText = styled.span`
  font-size: 18px;
  color: black;
  font-weight: 600;
  // margin-left:5px;
  // margin-top:5px;
`;
const TitleTextCover = styled.span`
  font-size: 14px;
  color: black;
  font-weight: 600;
  // margin-left:5px;
  // margin-top:5px;
`;
const TextAreaAuto = styled(TextareaAutosize)`
    height: 350px;
    width: 100%;
    border-radius: 2px;
    padding: 5px;
    overflow: scroll;
    border-color: rgb(0 0 0 / 32%);
    ::focus-visible {
      outline: ${COLOR.green100}auto 1px !important;
     }
    ::focus{
      border-color: ${COLOR.green100} !important;
  }
`;

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
  formControlText: {
    minWidth: 120,
    padding:12
  },
  selectEmpty: {
    marginTop: '4px',
  },
}));

const IntrectionModal = ({
  data,
  close,
  pageId,
  bookId,
  open,
  setAlertSakeBar,
  setdataloader = false,
}) => {
  const {showAlert, setAlertLoading} = useAlertLoading()
  const [interaction, setIntrection] = useState([]);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [seletedItem, setSeletedItem] = useState(null);
  const [changeItemIndex, setChangeItemIndex] = useState([]);
  const [error, setError] = useState(false);
  const scrollRef = useRef();
  const dispatch = useDispatch();
  const classes = useStyles();
  const [imageCoverLoader, setImageCoverLoader] = useState(false);
  const [youtubeUrlValidation,setYoutubeVideoValidation] = useState([])
  const[transcriptionProgress, setTranscriptionProgress] = useState(false);
  const [videoStreamReadyBySlot, setVideoStreamReadyBySlot] = useState({});
  const [interactionProgress, setInteractionProgress] = useState([]);

  useEffect(() => {
    return () => {
      setTranscriptionProgress(false);
    }
  }, [open]);

  useEffect(() => {
    if (!open) {
      setVideoStreamReadyBySlot({});
    }
  }, [open]);

  const getInteractionProgress = useCallback(async (ids) => {
    if (!ids?.length) {
      return;
    }
    const response = await dispatch(handleGetTranscationProgress(ids));
    if(response?.results?.length > 0) {
      setInteractionProgress(response?.results);
    }
  }, [dispatch]);

  useEffect(() => {
    if (interaction?.length > 0 && open) {
      const ids = interaction.map((item) => item.id);
      getInteractionProgress(ids);
    }
  }, [interaction, open, getInteractionProgress]);

  useEffect(() => {
    if (data && data.length > 0) {
      setIntrection(data);
    } else {
      setIntrection([
        {
          chapter: bookId,
          bookId,
          page: pageId,
          content: "",
          typeId: TYPES.video,
          category: "none",
          audio_metadata: [],
        },
      ]);
    }
    setYoutubeVideoValidation([])
  }, [data, bookId, pageId]);
  useEffect(() => {
    if (!open) {
      setSeletedItem(null);
      setChangeItemIndex([]);
    }
  }, [open]);

  const checkDisableInteraction = useMemo(() => {
    let disable = false;
    interaction.forEach((data) => {
      if (data?.typeId === TYPES.video) {
        if (data?.content?.length === 0 || !data?.content) {
          disable = true;
        }
      } else {
        if (data?.content?.length === 0 || !data?.content) {
          disable = true;
        }

        if (
          data?.audio_metadata?.length > 0 &&
          data?.category === "elcancion"
        ) {
          if(!data?.default_generic_name && data?.default_generic_name === ""){
            disable = true;
          }
          data.audio_metadata.forEach((data) => {
            if (data?.url?.length === 0 || !data?.url) {
              disable = true;
            }
            if (data?.genreName?.length === 0 || !data?.genreName) {
              disable = true;
            }
          });
        }
      }
    });

    return disable;
  }, [interaction]);
  const updateVideoData = async(interaction_data) => {
    if (!interaction_data) {
      return;
    }
    try {
      setdataloader(true);
      setLoading(true);
      if (has(interaction_data, "id")) {
        const isVideoType = interaction_data.typeId === TYPES.video;
        await dispatch(handleUpdateInteractions(interaction_data, isVideoType)); 
      } else{
        await dispatch(handleCreateInteractions(interaction_data));
      }
      setAlertSakeBar({
        open: true,
        message: "Interaction updated successfully!",
        severity: "success",
      });
    } catch (error) {
      Sentry.captureException(`297 Error in IntrectionModal: ${error}`);
      console.log(error);
    } finally {
      setLoading(false);
      setdataloader(false);
    }
  }

  const onUpdate = async () => {
    if (checkDisableInteraction || interaction?.length === 0) {
      setAlertSakeBar({
        open: true,
        message: "Please provide the necessary data.",
        severity: "error",
      });
      return;
    }
    try {
      close();
      setdataloader(true);
      setError(false);
      setLoading(true);
      const toUpdate = filter(
        interaction,
        (k, i) => !k.id || changeItemIndex.indexOf(k.id) !== -1
      );

      await Promise.allSettled(
        map(toUpdate, async (intre) => {
          if (has(intre, "id")) {
            const isVideoType = intre.typeId === TYPES.video;
            const intr = await dispatch(handleUpdateInteractions(intre, isVideoType));
            return intr;
          } else {
            const intr = await dispatch(handleCreateInteractions(intre));
            return intr;
          }
        })
      );
      setAlertSakeBar({
        open: true,
        message: "Interaction updated successfully!",
        severity: "success",
      });
    } catch (error) {
      Sentry.captureException(`297 Error in IntrectionModal: ${error}`);
      console.log(error);
    } finally {
      setImageCoverLoader(false);
      setLoading(false);
      setdataloader(false);
    }
  };
  const onDelete = async () => {
    if (!seletedItem) return;
    setDeleteLoader(true);
    const isVideoType = get(seletedItem, "typeId") === TYPES.video;
    const intr = await dispatch(
      handleDeleteInteractions(get(seletedItem, "id"), isVideoType)
    );
    if (has(intr, "id")) {
      setAlertSakeBar({
        open: true,
        message: "Interaction deleted successfully!",
        severity: "success",
      });
      // close();
    } else {
      setAlertSakeBar({
        open: true,
        message: "Error while deleting Interaction!",
        severity: "error",
      });
    }
    setDeleteLoader(false);
    setDeleteModal(false);
    setSeletedItem(null);
  };
  const onChange = (index, key, value) => {
    setIntrection((prevInteraction) => {
      const newInteraction = cloneDeep(prevInteraction);
      newInteraction[index][key] = value;
      return newInteraction;
    });

    setChangeItemIndex((prevChangeItemIndex) => {
      const newChangeItemIndex = cloneDeep(prevChangeItemIndex);
      if (!newChangeItemIndex.includes(interaction[index].id)) {
        newChangeItemIndex.push(interaction[index].id);
      }
      return newChangeItemIndex;
    });
  };

  const onAddIntrection = () => {
    const item = cloneDeep(interaction);
    item.push({
      chapter: bookId,
      bookId,
      page: pageId,
      content: "",
      typeId: TYPES.audio,
      category: "none",
      audio_metadata: [],
    });
    setIntrection(item);
    setTimeout(() => {
      if (scrollRef.current) {
        scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
      }
    }, 500);
  };
  const onRemove = (i) => {
    const item = cloneDeep(interaction);
    item.splice(i, 1);
    setIntrection(item);
  };

  useEffect(() => {
    const classNames = ["body-overflow-hidden"];

    if (open) {
      document.body.classList.add(...classNames);
    } else {
      document.body.classList.remove(...classNames);
    }
    return () => {
      document.body.classList.remove(...classNames);
    };
  }, [open]);

  const handleAddMoreGenre = (interactionIndex) => {
    try {
      setIntrection((prevInteraction) => {
        const updatedInteraction = {
          ...prevInteraction[interactionIndex],
          audio_metadata: [
            ...(prevInteraction[interactionIndex]?.audio_metadata || []),
            {
              id: moment().unix(),
              url: "",
              genreName: "",
            },
          ],
        };

        const newInteraction = [...prevInteraction];
        newInteraction[interactionIndex] = updatedInteraction;

        return newInteraction;
      });

      setChangeItemIndex((prevChangeItemIndex) => {
        const newChangeItemIndex = cloneDeep(prevChangeItemIndex);
        if (!newChangeItemIndex.includes(interaction[interactionIndex].id)) {
          newChangeItemIndex.push(interaction[interactionIndex].id);
        }
        return newChangeItemIndex;
      });
    } catch (error) {
      Sentry.captureException(`298 Error in IntrectionModal: ${error}`);
      console.log(error);
    }
  };

  const handleUpdateAudioMetadata = (
    interactionIndex,
    audioMetadataIndex,
    updatedData
  ) => {
    try {
      setIntrection((prevInteraction) => {
        const updatedInteraction = {
          ...prevInteraction[interactionIndex],
          audio_metadata:
            prevInteraction[interactionIndex]?.audio_metadata?.map(
              (audio, index) => {
                if (index === audioMetadataIndex) {
                  return {
                    ...audio,
                    ...updatedData,
                  };
                }
                return audio;
              }
            ) || [],
        };

        const newInteraction = [...prevInteraction];
        newInteraction[interactionIndex] = updatedInteraction;

        return newInteraction;
      });

      setChangeItemIndex((prevChangeItemIndex) => {
        const newChangeItemIndex = cloneDeep(prevChangeItemIndex);
        if (!newChangeItemIndex.includes(interaction[interactionIndex].id)) {
          newChangeItemIndex.push(interaction[interactionIndex].id);
        }
        return newChangeItemIndex;
      });
    } catch (error) {
      Sentry.captureException(`299 Error in IntrectionModal: ${error}`);
      console.log(error);
    }
  };

  const handleDeleteAudioMetadata = (interactionIndex, audioMetadataIndex) => {
    try {
      setIntrection((prevInteraction) => {
        const updatedInteraction = {
          ...prevInteraction[interactionIndex],
          audio_metadata:
            prevInteraction[interactionIndex]?.audio_metadata?.filter(
              (_, index) => index !== audioMetadataIndex
            ) || [],
        };

        const newInteraction = [...prevInteraction];
        newInteraction[interactionIndex] = updatedInteraction;

        return newInteraction;
      });

      setChangeItemIndex((prevChangeItemIndex) => {
        const newChangeItemIndex = cloneDeep(prevChangeItemIndex);
        if (!newChangeItemIndex.includes(interaction[interactionIndex].id)) {
          newChangeItemIndex.push(interaction[interactionIndex].id);
        }
        return newChangeItemIndex;
      });
    } catch (error) {
      Sentry.captureException(`300 Error in IntrectionModal: ${error}`);
      console.log(error);
    }
  };

  const generateTranscribe = async (id, j_id, intr) => {
    try {
      if(!id){
        showAlert(
          "Interaction ID is required.",
          "error",
        );
        setTranscriptionProgress(false);
        return;
      }
      setTranscriptionProgress(true);
      const progress = await handleTranscriptStatusCheck(id);
      if (progress?.success === true && progress.in_progress === true) {
        setTranscriptionProgress(false);
        showAlert(
          "Transcription is already in progress. Please wait until it finishes.",
          "warning",
        );
        return;
      }
      if (intr && intr.typeId === TYPES.video) {
        await handleMediaConverterTranscriptForVStream(intr.content, {
          id: id,
          type: 'interation',
          media_type: 'video',
        });
      } else {
        await handleTranscriptInteraction(id, j_id);
      }
      showAlert(
        "Submitted for transcription.",
        "success",
      );
      const getAllIds = interaction.map(item => item.id);
      getInteractionProgress(getAllIds);
    } catch (err) {
      Sentry.captureException(`generateTranscribe: ${err}`);
      showAlert(
        err?.message || "Something went wrong while starting transcription.",
        "error",
      );
    }finally{
      setTranscriptionProgress(false);
    }
  };
 const handleCheckUrlChange = (e, i) => {
  const value = e.target.value;

  setYoutubeVideoValidation(prev => {
    const existing = prev.find(p => p.index === i);
    const isValid = isYoutubeUrl(value);

    if (!isValid) {
      if (existing) {
        return prev.map(p =>
          p.index === i ? { ...p, error: true } : p
        );
      } else {
        return [...prev, { index: i, error: true }];
      }
    } else {
      return prev.filter(p => p.index !== i);
    }
  });
};
const onSwitchType = (i, e) => {
  setIntrection(prevInteraction => {
    const newInteraction = cloneDeep(prevInteraction);
    if (newInteraction[i]) {
      newInteraction[i]["content"] = "";
    }
    return newInteraction;
  });

  onChange(i, "typeId", e.target.value);
};

  return (
    <Modal
      open={open}
      onClose={close}
      style={{ height: "100%", width: "100%" }}
    >
      <ModalContent style={{ width: "70vw" }}>
        <DeleteModal
          deleteToggle={deleteModal}
          onDelete={onDelete}
          loading={deleteLoader}
          setDeleteToggle={setDeleteModal}
          message={`Are you sure you want to remove the interactions on pageId ${pageId}?`}
        />

        <Row style={{ justifyContent: "space-between" }}>
          <TitleText>Interactions</TitleText>
          <IconButton onClick={close} style={{ padding: 0 }}>
            <Close color="secondary" />
          </IconButton>
        </Row>
          <Button
            variant="contained"
            color="primary"
            startIcon={<Add />}
            onClick={onAddIntrection}
          >
            Add Interaction
          </Button>
        <ModalConfigArea ref={scrollRef} className="intrectionMdl">
          {map(interaction, (intr, i) => {
            const videoStreamKey =
              intr.id != null ? String(intr.id) : `idx-${i}`;
            const videoNeedsStreamReady =
              get(intr, "typeId") === TYPES.video;
            const videoStreamNotReady =
              videoNeedsStreamReady &&
              videoStreamReadyBySlot[videoStreamKey] !== true;
            const inProgress = interactionProgress.find(item => item.interactionId === intr.id)?.in_progress;
            return (
            <LinkArea key={intr.id + i}>
              <Row
                gutter={[24, 24]}
                style={{ justifyContent: "flex-end", display: "flex" }}
              >
                {get(intr, "typeId") != TYPES.youtube ?
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={
                      !intr.id ||
                      transcriptionProgress ||
                      videoStreamNotReady
                    }
                    style={{ marginLeft: 10 }}
                    startIcon={ inProgress ? <Loading white={true} size={16} /> :intr.srt ? <CheckCircle /> : null}
                    title={
                      videoNeedsStreamReady && intr.id && videoStreamNotReady
                        ? "Wait until upload finishes and the video plays without the processing overlay."
                        : undefined
                    }
                    onClick={() => {
                      generateTranscribe(intr.id,null,intr)
                    }}
                  >
                    Generate Transcript
                  </Button> : null}
                 {get(intr, "typeId") != TYPES.youtube ? <EditTranscript  url={intr.srt} onSave={()=>{}} enSrt={intr.srt_en} />:null}
                <IconButton
                  onClick={() => {
                    if (has(intr, "id")) {
                      setDeleteModal(true);
                      setSeletedItem(intr);
                    } else {
                      onRemove(i);
                    }
                  }}
                  className="generateDelete"
                  style={{ padding: 0, marginRight: 10 }}
                >
                  <Delete color="secondary" />
                </IconButton>
              </Row>
              <Row
                gutter={[24, 24]}
                style={{ marginTop: 10, marginRight: 0, marginLeft: 0 }}
              >
                <FormControl variant="outlined" className={classes.formControl}>
                  <InputLabel id="typeId" style={{ backgroundColor: "#fff" }}>
                    Type
                  </InputLabel>
                  <Select
                    labelId="typeId"
                    id="typeId"
                    value={`${get(intr, "typeId")}`}
                    onChange={(e) => {
                      onSwitchType(i,e)
                    }}
                  >
                    {map([TYPES.video, TYPES.audio, TYPES.youtube], (bk) => (
                      <MenuItem key={bk} value={bk}>
                        {bk}
                      </MenuItem>
                    ))}
                  </Select>
                  <div className="mt-10px w-full">
                    {get(intr, "typeId") == TYPES.audio && (
                      <Select
                        labelId="typeId"
                        id="typeId"
                        placeholder="Category"
                        value={`${get(intr, "category")}`}
                        onChange={(e) => {
                          onChange(i, "category", e.target.value);
                        }}
                        className="w-full"
                        defaultValue={"none"}
                      >
                        {map(InteractionCategoryType, (bk, index) => (
                          <MenuItem key={index} value={bk?.value}>
                            {bk?.label}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </div>
                </FormControl>
              </Row>
              <Row
                style={{
                  width: "100%",
                  marginTop: 16,
                  justifyContent: "center",
                  display: "block",
                }}
              >
                {get(intr, "typeId") == TYPES.video && (
                  <>
                    <VideoPicker
                      key={intr.id ? `vp-${intr.id}` : `vp-new-${i}`}
                      style={{ height: "auto" }}
                      hasDescription={false}
                      path={"/video/intraction"}
                      src={get(intr, "content")}
                      onChange={(item) => {
                        onChange(i, "content", item.url);
                        updateVideoData({
                          ...item, content: item.url,
                          chapter: bookId,
                          bookId,
                          page: pageId,
                          typeId: TYPES.video,
                          category: "none",
                          audio_metadata: [],
                        });
                      }}
                      to_cloudflare={true}
                      onStreamReadyChange={(ready) => {
                        const sk =
                          intr.id != null ? String(intr.id) : `idx-${i}`;
                        setVideoStreamReadyBySlot((p) =>
                          p[sk] === ready ? p : { ...p, [sk]: ready },
                        );
                      }}
                    />
                    <TitleTextCover>Cover :</TitleTextCover>
                    <div className="relative">
                      <PageImagePicker
                        src={get(intr, "poster")}
                        path={`/assignments/graphic_organizer`}
                        style={{ marginBottom: 24 }}
                        onChange={(item) => {
                          onChange(i, "poster", item.url);
                        }}
                        hasDescription={false}
                        setImageCoverLoader={setImageCoverLoader}
                      />
                      <IconButton
                        className="coverDelete"
                        color="secondary"
                        style={{
                          position: "absolute",
                          right: 0,
                          top: 0,
                          zIndex: 9999,
                          padding: 0,
                        }}
                        onClick={() => {
                          onChange(i, "poster", null);
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </div>
                  </>
                )}
                {get(intr, "typeId") == TYPES.audio && (
                  <>
                    {intr?.category === "elcancion" && (
                      <TextField
                        id="displayName"
                        name="displayName"
                        label="Género Name"
                        slotProps={{
                          inputLabel:{
                            shrink:true,
                            required:true
                          }
                        }}
                        style={{ marginBottom: "8px" }}
                        type="text"
                        required
                        variant="outlined"
                        value={intr?.default_generic_name}
                        onChange={(e) =>
                          onChange(i, "default_generic_name", e.target.value)
                        }
                      />
                    )}
                    <AudioPicker
                      style={{ justifyContent: "center" }}
                      onChange={(item) => {
                        onChange(i, "content", item);
                      }}
                    />
                    <TranscriptWithAudio audioUrl={get(intr, "content")} title={`Interaction Audio`}>
                    <ReactPlayer
                      className="cstmReactPlayer"
                      url={get(intr, "content")}
                      height="40px"
                      width="100%"
                      controls
                      playsinline
                      style={{
                        marginBottom: "8px",
                        marginLeft: 12,
                        marginRight: 12,
                      }}
                      config={{
                        file: { attributes: { controlsList: "nodownload" } },
                      }}
                    />
                    <div style={{ display: 'flex', justifyContent: 'center', mb: 1 }}>
                      <AudioDownloadButton audioUrl={get(intr, "content")} />
                    </div>
                    </TranscriptWithAudio>
                    {intr?.category === "elcancion" && (
                      <>
                        <Button
                          variant="contained"
                          color="primary"
                          style={{ marginBottom: 16, marginTop: "10px" }}
                          onClick={() => handleAddMoreGenre(i)}
                          startIcon={<Add />}
                        >
                          Género
                        </Button>
                        {intr?.audio_metadata?.map(
                          (element, meta_data_index) => {
                            const has_trans = Array.isArray(intr.transcribes) ? intr.transcribes?.find(k => k.id == element.id) : null;
                            const has_trans_en = Array.isArray(intr.srt_en_transcribe) ? intr.srt_en_transcribe?.find((k) => k.id == element.id) : null;
                            return (
                              <div>
                                  <Row
                                    gutter={[24, 24]}
                                    style={{ justifyContent: "flex-end", display: "flex" , marginBottom:"8px" }}
                                  >
                                    {/* <Button
                                      variant="contained"
                                      color="primary"
                                      style={{ marginLeft: 10 }}
                                      disabled={!intr.id||!element.id}
                                      startIcon={has_trans ? <CheckCircle /> : null}
                                      onClick={() => {
                                        generateTranscribe(intr.id, element.id)
                                      }}
                                    >
                                    Generate Transcript
                                    </Button> */}
                                   {/* {has_trans? <EditTranscript id={intr.id} j_id={element.id} url={has_trans.srt}  enSrt={has_trans.srt_en}  onSave={()=>{}} />:null} */}
                                <IconButton
                                  color="secondary"
                                  className="generateDelete"
                                  style={{
                                    padding: 0,
                                    marginBottom: "10px",
                                    float: "right",
                                  }}
                                  onClick={() => {
                                    handleDeleteAudioMetadata(
                                      i,
                                      meta_data_index
                                    );
                                  }}
                                />
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ marginLeft: 10 }}
                                    disabled={!intr.id || !element.id}
                                    startIcon={has_trans ? <CheckCircle /> : null}
                                    onClick={() => {
                                      generateTranscribe(intr.id, element.id)
                                    }}
                                  >
                                    Generate Transcript
                                  </Button>
                                  {has_trans ? <EditTranscript id={intr.id} j_id={element.id} url={has_trans?.srt} enSrt={has_trans_en?.srt_en} onSave={() => { }} /> : null}
                                  <IconButton
                                    className="coverDelete"
                                    color="secondary"
                                    style={{
                                      padding: 0,
                                      marginBottom: "10px",
                                      float: "right",
                                    }}
                                    onClick={() => {
                                      handleDeleteAudioMetadata(
                                        i,
                                        meta_data_index
                                      );
                                    }}
                                  >
                                    <Delete />
                                  </IconButton>

                                </Row>
                                <TextField
                                  id="displayName"
                                  name="displayName"
                                  label="Género Name"
                                  slotProps={{
                                    inputLabel:{
                                        shrink:true,
                                        required:true   
                                    }
                                  }}
                                  type="text"
                                  required
                                  variant="outlined"
                                  value={element?.genreName}
                                  onChange={(e) =>
                                    handleUpdateAudioMetadata(
                                      i,
                                      meta_data_index,
                                      { genreName: e.target.value }
                                    )
                                  }
                                />
                                <AudioUploaderChanger
                                  url={element?.url}
                                  onChange={(item) =>
                                    handleUpdateAudioMetadata(
                                      i,
                                      meta_data_index,
                                      { url: item }
                                    )
                                  }
                                />
                              </div>
                            );
                          }
                        )}
                      </>
                    )}
                  </>
                )}
                {get(intr, "typeId") == TYPES.youtube && (<>
                  <YouTubePlayer
                    key={`youtube-preview-${i}`}
                    playerId={intr.id ?? `youtube-player-${i}`}
                    url={get(intr, "content")}
                    is_valid={ get(intr, "content") && isYoutubeUrl(get(intr, "content"))}
                  />
                  <Row  style={{ marginTop: 20 }}>
                      <InputLabel id="textTip" style={{ backgroundColor: "#fff", paddingLeft: 2, paddingRight: 2 }}>Youtube video url.</InputLabel>
                      <TextField
                        id="textTip"
                        type="text"
                        minRows={3}
                        maxRows={5}
                        variant="outlined"
                        onBlur={e => handleCheckUrlChange(e,i)}
                        placeholder="https://youtube.com/***"
                        onChange={(e) => {
                          onChange(i, "content", e.target.value);
                        }}
                        value={get(intr, "content")}
                      />
                    {find(youtubeUrlValidation, ["index", i]) ? <FormHelperText error>{"Invalid youtube url."}</FormHelperText> : null}
                  </Row>
                </>)}
              </Row>
            </LinkArea>
          );
          })}
        </ModalConfigArea>
        <Row
          gutter={[24, 24]}
          style={{ marginTop: 16, marginRight: 0, marginLeft: 0 }}
        >
          <Button
            disabled={youtubeUrlValidation.length>0 || imageCoverLoader}
            fullWidth
            onClick={onUpdate}
            color="primary"
            variant="contained"
          >
            {loading ? <Loading white size={14} /> : null}{" "}
            {data ? "Update" : "Create"}
          </Button>
        </Row>
      </ModalContent>
    </Modal>
  );
};

export default IntrectionModal;

const AudioUploaderChanger = ({ onChange, url }) => {
  return (
    <SentryWrap>
      <AudioPicker
        onChange={(item) => onChange(item)}
        style={{
          paddingLeft: "0px",
          paddingRight: "0px",
          justifyContent: "center",
          marginTop: "10px",
        }}
      />
      <TranscriptWithAudio audioUrl={url} title={`Interaction Audio`}>
      <ReactPlayer
        className="cstmReactPlayer 222"
        url={url}
        height="40px"
        controls
        playsinline
        style={{
          marginBottom: "8px",
          marginLeft: 12,
          marginRight: 12,
          marginTop: 12,
        }}
        config={{
          file: { attributes: { controlsList: "nodownload" } },
        }}
      />
      </TranscriptWithAudio>
    </SentryWrap>
  );
};